import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var justify_space_between_vertical_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M7 4H17V8L7 8V4ZM7 16L17 16V20L7 20V16ZM20 11.25H4V12.75H20V11.25Z" }) });
export {
  justify_space_between_vertical_default as default
};
//# sourceMappingURL=justify-space-between-vertical.js.map
